import React, { Component } from 'react';

import { InputAdornment, MenuItem, TextField } from '@material-ui/core';
import * as moment from 'moment';
import { withRouter } from 'react-router-dom';
import { recordActivity } from '../AppUtil/AppUtil';

import MobileButton from '../Component/Common/Profile/Button';

let frequencies = [
	{
		value: 'monthly',
		label: 'Monthly'
	},
	{
		value: 'weekly',
		label: 'Weekly'
	},
	{
		value: 'biweekly',
		label: 'Bi-weekly'
	},
	{
		value: 'lumpsum',
		label: 'Lumpsum'
	}
];

class index extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loanAmount: '',
			annualInterestRate: '',
			noOfInstallments: '',
			frequency: 'monthly',
			firstPaymentDate: new Date(),
			maxInstallments: '',
			totalInterest: '',
			totalPayable: '',
			dateToday: new Date(),
			isTouched: { loanAmount: false, annualInterest: false, noOfInstallments: false }
		};
	}

	handleChange = event => {
		const newValue = event.target.value.toString().replace(/,/g, '');

		const numericValue = newValue.replace(/[^0-9]/g, '');

		const finalValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		switch (event.target.name) {
			case 'loan-amount':
				this.setState({
					loanAmount: finalValue,
					noOfInstallments: Math.round(parseFloat(event.target.value) / 1000),
					maxInstallments: numericValue / 1000,
					isTouched: { loanAmount: true }
				});
				break;
			case 'annual-interest-rate':
				this.setState({
					annualInterestRate: event.target.value || '',
					isTouched: { annualInterest: true }
				});

				break;
			case 'no-of-installments':
				this.setState({
					noOfInstallments: parseFloat(event.target.value) || '',
					isTouched: { noOfInstallments: true }
				});
				break;
			case 'frequency':
				if (event.target.value === 'lumpsum') {
					this.setState({ noOfInstallments: 1 });
				} else {
					this.setState({ frequency: event.target.value, isTouched: true });
				}

				break;
		}
	};

	handleDateChange = date => {
		this.setState({ firstPaymentDate: new Date(date) });
	};

	isFormComplete = () => {
		if (this.state.loanAmount !== 0 && this.state.noOfInstallments !== 0 && this.state.frequency !== '') {
			return true;
		} else return false;
	};

	calculateExtraDays = () => {
		const loanDisbursalDate = this.state.dateToday;
		const interestableExtraDay = moment(this.state.firstPaymentDate).diff(moment(loanDisbursalDate), 'days');
		return interestableExtraDay > 0 ? interestableExtraDay : 0;
	};

	getInterestByDay = days => {
		const iRate = this.state.annualInterestRate / 100;
		const interestRate = this.state.loanAmount * (1 + iRate / 365) ** days - this.state.loanAmount;
		return parseFloat(parseFloat(interestRate.toString()).toFixed(2));
	};

	addOnRateNote = () => {
		return (
			<div className="interest_disclaimer">
				<p style={{ width: '100%' }}>
					<span style={{ color: 'red', fontWeight: 'bolder', fontSize: '14px' }}>Note: </span> *Computed as
					monthly add-on rate (loan amount x interest rate = interest to be paid per month). Read our{' '}
					<a href="https://lendami.com.ph/faqs/" rel="noopener noreferrer" target="_blank">
						FAQs
					</a>{' '}
					for more details.
				</p>
			</div>
		);
	};

	PMT = (rate, nper, pv, fv, type) => {
		/*
		 * rate   - interest rate per month
		 * nper   - number of periods (months)
		 * pv   - present value
		 * fv   - future value
		 * type - when the payments are due:
		 *        0: end of the period, e.g. end of month (default)
		 *        1: beginning of period
		 */
		let pmt, pvif;

		fv || (fv = 0);
		type || (type = 0);

		if (rate === 0) return -(pv + fv) / nper;

		pvif = Math.pow(1 + rate, nper);

		pmt = (-rate * (pv * pvif + fv)) / (pvif - 1);

		if (type === 1) pmt /= 1 + rate;
		return pmt;
	};

	calculateInterest = () => {
		const frequency = this.state.frequency;
		const numberOfInstallments = this.state.noOfInstallments;
		const originalPrincipal = this.state.loanAmount.replace(/\,/g, '');

		const monthlyInterest = this.state.annualInterestRate;
		const numberOfDays = 0;

		let newInterest = 0;
		if (frequency === 'monthly') newInterest = monthlyInterest / 100;
		if (frequency === 'weekly') newInterest = (monthlyInterest * 12) / 52 / 100;
		if (frequency === 'biweekly') newInterest = (monthlyInterest * 12) / (52 / 2) / 100;
		// if (frequency === 'lumpsum') newInterest = (monthlyInterest * 12) / 365 / 100;
		if (frequency === 'lumpsum') newInterest = monthlyInterest / 100;

		let currentPrincipal = originalPrincipal;
		let totalPrincipal = 0;
		let totalInterest = 0;
		let principalAmount = 0;
		const payable = 0;
		let interestAmount = 0;
		const amortizationTable = [];

		// const NO_OF_DAYS_IN_YEAR = 365;

		// const days = moment(this.state.firstPaymentDate).diff(moment(), 'days');
		// interestAmount = currentPrincipal * (1 + newInterest / (365 / 12)) ** days - currentPrincipal;
		// if (frequency !== 'lumpsum') {
		interestAmount = currentPrincipal * newInterest;
		principalAmount = originalPrincipal / numberOfInstallments;
		for (let index = 0; index < numberOfInstallments; index++) {
			// If it's the last installment, the principal amount should be the remaining balance
			if (index === numberOfInstallments - 1) {
				principalAmount = +parseFloat(currentPrincipal).toFixed(2);
			}
			const installmentCount = index + 1;
			const payable = +principalAmount + interestAmount;

			amortizationTable.push({
				installmentCount: installmentCount,
				principal: currentPrincipal,
				interestAmount: interestAmount.toFixed(2),
				payable: Math.abs(payable.toFixed(2)),
				principalAmount: Math.abs(principalAmount.toFixed(2))
			});

			currentPrincipal = parseFloat(currentPrincipal).toFixed(2) - parseFloat(principalAmount).toFixed(2);
			totalPrincipal = Math.abs(originalPrincipal);
			totalInterest += interestAmount;
		}
		// } else {

		// 	totalInterest = newInterest * numberOfDays * originalPrincipal;
		// }
		if (this.state.frequency === 'lumpsum') {
			totalInterest = newInterest * numberOfDays * originalPrincipal;
		}

		return {
			amortizationTable: amortizationTable,
			principalAmount: totalPrincipal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') || originalPrincipal,
			totalInterest: totalInterest.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		};
	};

	isFrequencyNotLumpsump = () => {
		return frequencies;
	};

	isFrequencyLumpsump = () => {
		return frequencies.filter(m => m.value !== 'lumpsum');
	};

	render() {
		const formatter = new Intl.NumberFormat('ph', {
			style: 'currency',
			currency: 'PHP'
		});

		console.log(this.state.frequency);

		const { principalAmount, totalInterest, amortizationTable } = this.calculateInterest();

		const principalAmountToNumber = parseFloat(principalAmount.toString().replace(/,/g, ''));
		const totalInterestToNumber = parseFloat(totalInterest.toString().replace(/,/g, ''));
		const totalAmount = principalAmountToNumber + totalInterestToNumber;

		// frequencies = this.state.noOfInstallments > 0 ? this.isFrequencyNotLumpsump() : this.isFrequencyLumpsump();
		frequencies = this.isFrequencyNotLumpsump();
		return (
			<>
				<div
					className={`loan-calculator-container ${
						this.props.match.path === '/loan-calculator' ? 'center' : ''
					}`}>
					<h3>Loan Calculator</h3>
					<form>
						<div className="calculator-wrapper">
							<div className="calculator-field">
								<p>Loan Amount:</p>
								<TextField
									className="number-field"
									id="loan-amount"
									name="loan-amount"
									InputLabelProps={{
										shrink: true
									}}
									variant="outlined"
									onChange={e => {
										this.handleChange(e);
									}}
									value={this.state.loanAmount}
									InputProps={{
										startAdornment: <InputAdornment position="start">₱</InputAdornment>,
										className: 'bold-important'
									}}
									error={this.state.isTouched.loanAmount && this.state.loanAmount < 1000}
									helperText={
										this.state.isTouched.loanAmount && this.state.loanAmount < 1000
											? 'Amount cannot be less than ₱1,000'
											: null
									}
								/>
							</div>
							<div className="calculator-field">
								<p>Monthly Interest Rate:</p>
								<TextField
									className="number-field"
									id="annual-interest-rate"
									name="annual-interest-rate"
									type="number"
									InputLabelProps={{
										shrink: true
									}}
									disabled={this.state.loanAmount < 1000}
									variant="outlined"
									onChange={e => {
										this.handleChange(e);
									}}
									error={
										(this.state.isTouched.annualInterest &&
											parseFloat(this.state.annualInterestRate) < 0) ||
										(this.state.isTouched.annualInterest &&
											parseFloat(this.state.annualInterestRate) > 6)
											? `The interest rate cannot be less than 0% or more than 6%`
											: ''
									}
									helperText={
										(this.state.isTouched.annualInterest &&
											parseFloat(this.state.annualInterestRate) < 0) ||
										(this.state.isTouched.annualInterest &&
											parseFloat(this.state.annualInterestRate) > 6)
											? `The interest rate cannot be less than 0% or more than 6%`
											: ''
									}
									// onInput={e => {
									// 	e.target.value = parseInt(e.target.value).toString().slice(0, 3);
									// }}

									value={this.state.annualInterestRate}
									inputProps={{ step: 0.05 }}
									InputProps={{
										endAdornment: <InputAdornment position="start">%</InputAdornment>,
										className: 'bold-important'
									}}
								/>
							</div>
							<div className="calculator-field">
								<p># of Installments:</p>
								<TextField
									className="number-field"
									id="no-of-installments"
									name="no-of-installments"
									type="number"
									InputLabelProps={{
										shrink: true
									}}
									disabled={this.state.loanAmount < 1000}
									InputProps={{ className: 'bold-important' }}
									variant="outlined"
									onChange={e => {
										this.handleChange(e);
									}}
									value={this.state.noOfInstallments}
									error={
										this.state.isTouched.noOfInstallments &&
										(this.state.noOfInstallments > this.state.maxInstallments ||
											(this.state.isTouched.noOfInstallments &&
												this.state.noOfInstallments <= 0) ||
											(this.state.isTouched.noOfInstallments &&
												this.state.noOfInstallments == ''))
									}
									onInput={e => {
										e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
									}}
									helperText={
										this.state.isTouched.noOfInstallments &&
										(this.state.noOfInstallments > this.state.maxInstallments ||
											(this.state.isTouched.noOfInstallments &&
												this.state.noOfInstallments <= 0) ||
											(this.state.isTouched.noOfInstallments &&
												this.state.noOfInstallments == ''))
											? `Minimum amount per installment is Php 1,000. Number of installments cannot be 0 or more than ${this.state.maxInstallments}.`
											: null
									}
								/>
							</div>

							<div className="calculator-field">
								<p>Frequency:</p>
								<TextField
									className="number-field"
									id="frequency"
									name="frequency"
									disabled={this.state.loanAmount < 1000 || this.state.noOfInstallments <= 1}
									InputProps={{ className: 'bold-important' }}
									select
									value={this.state.noOfInstallments === 1 ? 'lumpsum' : this.state.frequency}
									onChange={e => {
										this.handleChange(e);
									}}
									variant="outlined">
									{' '}
									{frequencies.map(option => (
										<MenuItem key={option?.value} value={option?.value}>
											{option?.label}
										</MenuItem>
									))}
								</TextField>
							</div>

							{/* <div className="calculator-field">
								<p> First Payment Date</p>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										className="number-field"
										disableToolbar
										variant="inline"
										inputVariant="outlined"
										format="MM/dd/yyyy"
										margin="normal"
										id="date-picker-inline"
										name="first-payment-date"
										value={this.state.firstPaymentDate}
										onChange={e => {
											this.handleDateChange(e);
										}}
										KeyboardButtonProps={{
											'aria-label': 'change date'
										}}
									/>
								</MuiPickersUtilsProvider>
							</div> */}

							<hr className="divider" />
							<div className="calculator-field">
								<p> Total Interest:</p>
								<TextField
									disabled
									id="read-only"
									className="number-field"
									InputProps={{
										readOnly: true,
										startAdornment: <InputAdornment position="start">₱</InputAdornment>,
										style: {
											backgroundColor: '#d9d9d9'
										},
										className: 'bold-important'
									}}
									variant="outlined"
									value={this.isFormComplete() ? totalInterest : 0}
								/>
							</div>
							<div className="calculator-field">
								<p>Total Principal:</p>
								<TextField
									disabled
									id="read-only"
									className="number-field"
									InputProps={{
										readOnly: true,
										startAdornment: <InputAdornment position="start">₱</InputAdornment>,
										style: {
											backgroundColor: '#d9d9d9'
										},
										className: 'bold-important'
									}}
									variant="outlined"
									value={this.isFormComplete() ? principalAmount : 0}
								/>
							</div>
							<div className="calculator-field">
								<p>Total:</p>
								<TextField
									disabled
									id="read-only"
									className="number-field"
									InputProps={{
										readOnly: true,
										startAdornment: <InputAdornment position="start">₱</InputAdornment>,
										style: {
											backgroundColor: '#d9d9d9'
										},
										className: 'bold-important'
									}}
									variant="outlined"
									value={
										this.isFormComplete()
											? totalAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
											: 0
									}
								/>
							</div>
							<div className="calculator_table_container">
								<table className="calculator_table" style={{ fontSize: '12px' }}>
									<tr className="head_row">
										<th>Loan Amount</th>
										<th># of Installments</th>
										<th>Interest Rate</th>
										<th>Interest Payable</th>
										<th>Principal Payment</th>
										<th>Total Payable Amount</th>
									</tr>
									<tbody id="table_data" style={{ fontSize: '13px' }}>
										{amortizationTable.length > 0 ? (
											amortizationTable.map((item, index) => {
												return (
													<tr>
														<td className="bold-important">
															{formatter.format(item.principal)}
														</td>
														<td className="bold-important">{item.installmentCount}</td>
														<td className="bold-important">
															{this.state.annualInterestRate}%
														</td>
														<td className="bold-important">
															{formatter.format(item.interestAmount)}
														</td>
														<td className="bold-important">
															{formatter.format(item.principalAmount)}
														</td>
														<td className="bold-important">
															{formatter.format(item.payable)}
														</td>
													</tr>
												);
											})
										) : (
											<tr>
												<td className="bold-important">₱0.00</td>
												<td className="bold-important">0</td>
												<td className="bold-important">₱0.00</td>
												<td className="bold-important">₱0.00</td>
												<td className="bold-important">₱0.00</td>
												<td className="bold-important">₱0.00</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</form>
					{this.addOnRateNote()}
				</div>
				{this.props.match.path == '/loan-calculator' && (
					<MobileButton
						style={{ margin: '20px auto' }}
						onClick={() => {
							recordActivity('EXIT', 'Loan Calculator');
							window.history.back();
						}}
					/>
				)}
			</>
		);
	}
}

export default withRouter(index);
